export default "__VITE_ASSET__BlV1CBz8__"